(function () {
  var today = new Date();
  var yyyy = today.getFullYear();

  // Helpers (LOCAL YYYY-MM-DD, sin UTC)
  function pad2(n) { return String(n).padStart(2, "0"); }
  function ymdLocal(d) {
    return d.getFullYear() + "-" + pad2(d.getMonth() + 1) + "-" + pad2(d.getDate());
  }
  function ddmm(ymd) {
    return ymd.slice(8,10) + "/" + ymd.slice(5,7);
  }

  // Holidays by locale key
  var publicHolidays = {
    esp: [
      (yyyy+1)+"-01-01", (yyyy+1)+"-01-06",
      yyyy+"-01-01", yyyy+"-01-06",
      yyyy+"-04-18", yyyy+"-04-17", yyyy+"-04-21",
      yyyy+"-05-01", yyyy+"-05-02",
      yyyy+"-06-23", yyyy+"-06-24",
      yyyy+"-08-15",
      yyyy+"-09-11", yyyy+"-09-12",
      yyyy+"-10-12",
      yyyy+"-11-01",
      yyyy+"-12-06",
      yyyy+"-12-25", yyyy+"-12-26"
    ],

    // PT: mete aquí tus festivos (los móviles hay que actualizarlos cada año)
    // Te dejo los fijos nacionales más comunes:
    pt: [
      (yyyy+1)+"-01-01",
      yyyy+"-01-01",
      yyyy+"-04-25",
      yyyy+"-05-01",
      yyyy+"-06-10",
      yyyy+"-08-15",
      yyyy+"-10-05",
      yyyy+"-11-01",
      yyyy+"-12-01",
      yyyy+"-12-08",
      yyyy+"-12-25"
    ]
  };

  // Check if there is a match in the array (LOCAL date)
  Date.prototype.isPublicHoliday = function (data) {
    if (!data) return 1;
    return data.indexOf(ymdLocal(this)) > -1 ? 0 : 1;
  };

  // Calculation of business days
  Date.prototype.businessDays = function (d, holidays) {
    var t = new Date(this); // copy date.
    while (d) {
      t.setDate(t.getDate() + 1);
      switch (t.getDay()) {
        case 0:
        case 6:
          break; // sunday & saturday
        default:
          d -= t.isPublicHoliday(holidays);
      }
    }
    return ymdLocal(t); // LOCAL YYYY-MM-DD
  };

  document.addEventListener('DOMContentLoaded', function () {
    var wrap = document.querySelector('.estimated-delivery-date-wrap');
    if (!wrap) return;

    var earliestEl = document.getElementById('earliest-day');
    var latestEl = document.getElementById('latest-day');
    if (!earliestEl || !latestEl) return;

    var earliestAdd = parseInt(wrap.getAttribute('data-earliest-add') || "1", 10);
    var latestAdd = parseInt(wrap.getAttribute('data-latest-add') || "3", 10);
    var holidaysKey = wrap.getAttribute('data-holidays') || "esp";
    var holidays = publicHolidays[holidaysKey] || publicHolidays.esp;

    var orderDate = ymdLocal(new Date());

    var earliestDate = new Date(orderDate).businessDays(earliestAdd, holidays);
    var deliveryDate = new Date(orderDate).businessDays(latestAdd, holidays);

    earliestEl.innerHTML = ddmm(earliestDate);
    latestEl.innerHTML = ddmm(deliveryDate);
  });
})();
